(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-banner-slider')) {
    class HeroBannerSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('.hero-slider__track');
        this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
        this.prevButton = this.querySelector('[data-nav="prev"]');
        this.nextButton = this.querySelector('[data-nav="next"]');
        this.current = 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onNavClick = this.onNavClick.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onVisibility = this.onVisibility.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.stopAutoplay = this.stopAutoplay.bind(this);
        this.startAutoplay = this.startAutoplay.bind(this);

        this.prevButton?.addEventListener('click', this.onNavClick);
        this.nextButton?.addEventListener('click', this.onNavClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('mouseenter', this.stopAutoplay);
        this.addEventListener('mouseleave', this.startAutoplay);
        this.addEventListener('focusin', this.stopAutoplay);
        this.addEventListener('focusout', this.startAutoplay);
        window.addEventListener('resize', this.onResize);
        document.addEventListener('visibilitychange', this.onVisibility);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.bindSwipe();
        this.update(false);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      get pageCount() {
        return Math.max(this.slides.length, 1);
      }

      onNavClick(event) {
        this.go(event.currentTarget.getAttribute('data-nav') === 'next' ? 1 : -1);
      }

      onResize() {
        this.update(false);
      }

      onVisibility() {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(-1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(1);
        }
      }

      onBlockSelect(event) {
        if (!this.contains(event.target)) return;
        const slide = event.target.closest('.hero-slider__slide');
        if (!slide) return;
        const index = this.slides.indexOf(slide);
        if (index < 0) return;
        this.current = index;
        this.update();
        this.stopAutoplay();
      }

      onBlockDeselect(event) {
        if (!this.contains(event.target)) return;
        this.startAutoplay();
      }

      go(step) {
        const total = this.pageCount;
        if (total <= 1) return;
        this.current = (this.current + step + total) % total;
        this.update();
        this.startAutoplay();
      }

      update(animate) {
        if (!this.track) return;
        const shouldAnimate = animate !== false && !this.reducedMotion.matches;
        this.track.style.transition = shouldAnimate ? '' : 'none';
        this.track.style.transform = 'translate3d(' + -this.current * 100 + '%, 0, 0)';
        this.syncVisibility();
      }

      syncVisibility() {
        this.slides.forEach((slide, index) => {
          const visible = index === this.current;
          slide.toggleAttribute('inert', !visible);
          slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      }

      startAutoplay() {
        this.stopAutoplay();
        if (this.dataset.autoplay !== 'true' || this.reducedMotion.matches || this.pageCount <= 1) return;
        const speed = Number(this.dataset.speed || 5) * 1000;
        this.autoplayTimer = setInterval(() => this.go(1), speed);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      bindSwipe() {
        const viewport = this.querySelector('.hero-slider__viewport');
        if (!viewport) return;
        let startX = 0;
        let startY = 0;
        let dx = 0;
        let axis = null;
        let tracking = false;

        viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          tracking = true;
          startX = event.clientX;
          startY = event.clientY;
          dx = 0;
          axis = null;
        });

        viewport.addEventListener('pointermove', (event) => {
          if (!tracking) return;
          const moveX = event.clientX - startX;
          const moveY = event.clientY - startY;
          if (axis === null && (Math.abs(moveX) > 8 || Math.abs(moveY) > 8)) {
            axis = Math.abs(moveX) > Math.abs(moveY) ? 'x' : 'y';
          }
          if (axis === 'x') dx = moveX;
        });

        const end = () => {
          if (!tracking) return;
          tracking = false;
          if (axis === 'x' && Math.abs(dx) > 40) {
            this.go(dx < 0 ? 1 : -1);
            this.suppressClick = true;
          }
          axis = null;
          dx = 0;
        };

        viewport.addEventListener('pointerup', end);
        viewport.addEventListener('pointercancel', end);
        viewport.addEventListener(
          'click',
          (event) => {
            if (!this.suppressClick) return;
            event.preventDefault();
            event.stopPropagation();
            this.suppressClick = false;
          },
          true
        );
      }
    }

    customElements.define('hero-banner-slider', HeroBannerSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('latest-product-card')) {
    class LatestProductCard extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.image = this.querySelector('.latest-products__image');
        this.price = this.querySelector('[data-price]');
        this.variantInput = this.querySelector('.product-variant-id');
        this.button = this.querySelector('.latest-products__add');
        this.buttonLabel = this.button ? this.button.querySelector('span') : null;
        const source = this.querySelector('[data-variants]');
        this.variants = source ? JSON.parse(source.textContent) : [];
        this.optionSelects = Array.from(this.querySelectorAll('[data-option-index]'));
        this.optionSelects.forEach((select) => {
          select.addEventListener('change', () => this.updateVariant());
        });
      }

      updateVariant() {
        const selected = this.optionSelects
          .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
          .map((select) => select.value);
        const variant = this.variants.find((item) =>
          selected.every((value, index) => item.options[index] === value)
        );
        if (!variant || !this.variantInput) return;

        this.variantInput.value = variant.id;
        if (this.price) this.price.textContent = variant.price;
        if (variant.image && this.image) this.image.src = variant.image;
        if (this.button) {
          this.button.disabled = !variant.available;
          if (this.buttonLabel) this.buttonLabel.textContent = variant.available ? 'Quick Add' : 'Sold out';
        }
      }
    }

    customElements.define('latest-product-card', LatestProductCard);
  }

  } catch(e) { console.error(e); }
})();
})();
